import Scene = Phaser.Scene;
import {lazyInject} from "@/container";
import {TYPES} from "@/types";
import {SceneService} from "@/services/scene-service";
import SceneUtils from "@/utils/scene-utils";
import {LoadUtils, LoaderState} from "@/utils/load-utils";
import {Keys} from "@/constants/key";
import {GameState} from "@/constants/game-state";
import {SceneName} from "@/model/scene-name";
import PlayerStore from "@/store/player";
import {Creature} from "@/store/level/types";
import ArtifactUtils from "@/utils/artifact-utils";
import BattleStore from "@/store/battle";
import {Reloadable} from "@/scenes/reloadable";

export default class CreatureLoadScene extends Scene implements Reloadable {

    @lazyInject(TYPES.SceneService)
    private sceneService!: SceneService;

    private canvas!: HTMLCanvasElement;

    private progressShown: boolean = false;

    private enemyCreatures!: Creature[];

    private loaderState!: LoaderState;

    constructor() {
        super({ key: 'CreatureLoadScene' });
    }

    init(data: any) {
        this.enemyCreatures = data.creatures;
    }

    public preload(): void {
        this.canvas = this.sys.game.canvas;
        SceneUtils.setCurrentScene(this);
    }

    private params!: any;

    public create(params: any): void {
        this.params = params;

        if (!GameState.CREATURE_RESOURCES_LOADED) {
            LoadUtils.loadCreatureSceneMusic(this);

            PlayerStore.getPlayer()!.creatures.forEach((c: Creature) => {
                this.load.image(Keys.profileCreature(c.imageId), `assets/profile/creatures/${c.imageId}.png`);
            });

            if (this.enemyCreatures) {
                ArtifactUtils.loadArtifactsByCreatures(this, this.enemyCreatures);
            }
            GameState.CREATURE_RESOURCES_LOADED = true;
        }
        this.load.start();
        this.showProgress();
    }

    private showProgress(){
        if (!this.progressShown){
            this.loaderState = new LoaderState();
            // LoadUtils.drawClouds(this, this.canvas);
            LoadUtils.drawLoadingScreen(this);
            LoadUtils.showSimpleLoadingScreen(this, this.canvas, this.loaderState);
        } else if(this.load.isReady()) {
            this.proceedToScreen();
            return;
        }

        this.load.once(Phaser.Loader.Events.COMPLETE, () => {
            this.proceedToScreen();
        });
    }

    private proceedToScreen(){
        this.scene.start(SceneService.getSceneKey(SceneName.CREATURE_SCENE), this.params);
        this.progressShown = true;
    }

    update(time: number, delta: number){
        if(this.loaderState){
            this.loaderState.update(time, delta);
        }
    }

    public reload(): void {
        this.sceneService.startSceneInstant(this, SceneName.CREATURE_LOAD_SCENE);
    }
}
